import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService as AuthGuard } from '../core/services/auth-guard.service';
import { NotfoundComponent } from '../utils/notfound/notfound.component';
import { UsuariosComponent } from './Admin/Operadores/consulta/usuarios.component';
import { NuevousuarioComponent } from './Admin/Operadores/nuevos/nuevousuario.component';
import { AlertasComponent } from './alertas/alertas.component';
import { CarritoComponent } from './carrito/carrito.component';
import { ContactoComponent } from './contacto/contacto.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DetallehomeComponent } from './detalle/detallehome.component';
import { HomeLayoutComponent } from './home-layout/home-layout.component';
import { InformesComponent } from './informes/informes.component';
import { UploadinformesComponent } from './informes/upload/uploadinformes.component';
import { AzDetalleComponent } from './inventariado-detalle/az-detalle/az-detalle.component';
import { ContenedorDetalleComponent } from './inventariado-detalle/contenedor-detalle/contenedor-detalle.component';
import { ExpedienteDetalleComponent } from './inventariado-detalle/expediente-detalle/expediente-detalle.component';
import { InventariosComponent } from './inventarios/inventarios.component';
import { MaterialesComponent } from './materiales/materiales.component';
import { PerfilComponent } from './perfil/perfil.component';
import { ConsultaComponent } from './prestamos/consulta/consulta.component';
import { RedirectorComponent } from './redirector/redirector.component';
import { SolicitudServicioComponent } from './solicitud-servicio/solicitud-servicio.component';
import { ErrorPageComponent } from '../utils/error-page/error-page.component';
import { UserControlCliComponent } from './user-control-cli/user-control-cli.component';
import { InventarioSSOComponent } from './user-control-cli/inventario-sso/inventario-sso.component';
import { CargaInventariosComponent } from './carga-inventarios/carga-inventarios.component';
import { ExtraerInventariosComponent } from './inventarios/extraer-inventarios/extraer-inventarios.component';
const routes: Routes = [
  {
    path: 'error',
    component: ErrorPageComponent
  },
  {
    path: 'docout',
    component: HomeLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'notfound',
        component: NotfoundComponent,
        outlet: 'contenido'

      },
      {
        path: '',
        component: DashboardComponent,
        outlet: 'contenido'
      },
      {
        path: 'panelmando',
        component: DashboardComponent,
        outlet: 'contenido'
      },
      {
        path: 'downinformes',
        component: InformesComponent,
        outlet: 'contenido'
      },
      {
        path: 'upinformes',
        component: UploadinformesComponent,
        outlet: 'contenido'
      },
      {
        path: 'consulta',
        component: ConsultaComponent,
        outlet: 'contenido'
      },
      {
        path: 'detalle/:id',
        component: DetallehomeComponent,
        outlet: 'contenido'
      },
      {
        path: 'detalle/:id/:sso',
        component: DetallehomeComponent,
        outlet: 'contenido'
      },
      {
        path: 'usuarios',
        component: UsuariosComponent,
        outlet: 'contenido'
      },
      {
        path: 'nuevousuario',
        component: NuevousuarioComponent,
        outlet: 'contenido'
      },
      {
        path: 'servicio/:servicio',
        component: SolicitudServicioComponent,
        canDeactivate: [AuthGuard],
        outlet: 'contenido'
      },
      {
        path: 'perfil',
        component: PerfilComponent,
        outlet: 'contenido'
      },
      {
        path: 'alertas',
        component: AlertasComponent,
        outlet: 'contenido'
      },
      {
        path: 'materiales',
        component: MaterialesComponent,
        outlet: 'contenido'
      },
      {
        path: 'inventarios',
        component: InventariosComponent,
        outlet: 'contenido'
      },
      {
        path: 'contenedores',
        component: InventariosComponent,
        outlet: 'contenido'
      },
      {
        path: 'az',
        component: InventariosComponent,
        outlet: 'contenido'
      },
      {
        path: 'inventarios/:keyword',
        component: InventariosComponent,
        outlet: 'contenido'
      },
      {
        path: 'expediente',
        component: ExpedienteDetalleComponent,
        outlet: 'contenido'
      },
      {
        path: 'contenedor/:id',
        component: ContenedorDetalleComponent,
        outlet: 'contenido'
      },
      {
        path: 'az/:id',
        component: AzDetalleComponent,
        outlet: 'contenido'
      },
      {
        path: 'carrito',
        component: CarritoComponent,
        outlet: 'contenido'
      },
      {
        path: 'infocontacto',
        component: ContactoComponent,
        outlet: 'contenido'
      },
      {
        path: 'redirector',
        component: RedirectorComponent,
        outlet: 'contenido'
      },
      {
        path: 'usercontrolcli',
        component: UserControlCliComponent,
        outlet: 'contenido'
      },
      {
        path: 'inventariosso',
        component: InventarioSSOComponent,
        outlet: 'contenido'
      },
      {
        path: 'cargainventario',
        component: CargaInventariosComponent,
        outlet: 'contenido'
      },
      {
        path: 'informeCliente',
        component: ExtraerInventariosComponent,
        outlet: 'contenido'
      }
    ]
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeModuleRoutingModule { }
